export default "__VITE_ASSET__LK4drlcs__"